import {
  REQUEST_QUICKLISTS, RECEIVE_QUICKLISTS, ERROR_QUICKLISTS,
  REQUEST_QUICKLISTTEMPLATES, RECEIVE_QUICKLISTTEMPLATES, ERROR_QUICKLISTTEMPLATES,
  REQUEST_QUICKLISTCOUNT, RECEIVE_QUICKLISTCOUNT, ERROR_QUICKLISTCOUNT,
  REQUEST_QUICKLISTRESULT, RECEIVE_QUICKLISTRESULT, ERROR_QUICKLISTRESULT,
  REQUEST_QUICKLISTSAVE, RECEIVE_QUICKLISTSAVE, ERROR_QUICKLISTSAVE,
  RECEIVE_QUICKLISTGROUP, REQUEST_QUICKLISTGROUP, ERROR_QUICKLISTGROUP,
  REQUEST_QUICKLISTDELETE, RECEIVE_QUICKLISTDELETE, ERROR_QUICKLISTDELETE,
  SET_CURRENT_QUICKLIST_ID, SET_CURRENT_QUICKLIST_ROW_INDEX,
} from "typeConstants";
import { quickList as initialState } from "../../initialState.tsx";
import { cloneDeep } from "lodash";

const quickList = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_QUICKLISTS:
    case REQUEST_QUICKLISTGROUP:
      return {
        ...state,
        isFetchingQuickLists: true
      };
    case REQUEST_QUICKLISTTEMPLATES:
      return {
        ...state,
        isFetchingQuickListTemplates: true
      };
    case REQUEST_QUICKLISTCOUNT: {
      // need to update the 'active' count to isfetching
      // todo: need to reduce the copied code in this reducer.
      let lists = cloneDeep(state.quickLists);
      let currentlist = lists.find(x => x.id === action.payload);
      if (currentlist !== undefined) {
        currentlist.count.isFetching = true;
      }
      return {
        ...state,
        quickLists: lists
      };
    }
    case REQUEST_QUICKLISTRESULT: {
      // need to update the 'active' count to isfetching
      let lists = cloneDeep(state.quickLists);
      let currentlist = lists.find(x => x.id === action.payload);
      if (currentlist !== undefined) {
        currentlist.result.isFetching = true;
      }
      return {
        ...state,
        quickLists: lists
      };
    }
    case REQUEST_QUICKLISTSAVE: {
      // need to update the 'active' count to isfetching
      let lists = cloneDeep(state.quickLists);
      let currentlist = lists.find(x => x.id === action.payload);
      if (currentlist !== undefined) {
        currentlist.result.isFetching = true;
        currentlist.result.asOfDate = null;
      }
      return {
        ...state,
        quickLists: lists
      };
    }
    case REQUEST_QUICKLISTDELETE: {
      // need to update the 'active' count to isfetching
      let lists = cloneDeep(state.quickLists);
      let currentlist = lists.find(x => x.id === action.payload);
      let currentListId = 0;
      if (currentlist !== undefined) {
        currentlist.result.isFetching = true;
        if (action.payload !== state.currentQuicklistId) {
          currentListId = state.currentQuicklistId;
        }
      }
      return {
        ...state,
        currentQuicklistId: currentListId,
        quickLists: lists
      };
    }
    case RECEIVE_QUICKLISTS:
      return {
        ...state,
        quickLists: action.payload,
        quickListsLoaded: true,
        isFetchingQuickLists: false
      };
    case RECEIVE_QUICKLISTTEMPLATES:
      if (Array.isArray(state.quickListTemplates) && state.quickListTemplates.length) {
        return {
          ...state,
          isFetchingQuickListTemplates: false
        };
      }
      return {
        ...state,
        quickListTemplates: action.payload.quickListTemplates,
        isFetchingQuickListTemplates: false
      };
    case RECEIVE_QUICKLISTCOUNT: {
      // need to update the 'active' count to done Fetching
      let lists = cloneDeep(state.quickLists);
      let currentList = lists.find(x => x.id === action.payload.id);
      if (currentList !== undefined) {
        currentList.count = action.payload;
        currentList.count.isFetching = false;
      }
      return {
        ...state,
        quickLists: lists
      };
    }
    case RECEIVE_QUICKLISTRESULT: {
      // need to update the 'active' count to done Fetching
      let lists = cloneDeep(state.quickLists);
      let currentList = lists.find(x => x.id === action.payload.id);
      if (currentList !== undefined) {
        currentList.result = action.payload;
        currentList.result.isFetching = false;
      }
      return {
        ...state,
        quickLists: lists
      };
    }
    case RECEIVE_QUICKLISTGROUP: {
      return {
        ...state,
        quickLists: action.payload,
        isFetchingQuickLists: false
      };
    }

    case RECEIVE_QUICKLISTSAVE: {
      let items = cloneDeep(state.quickLists);
      let index = items.findIndex(x => x.id === action.payload.id);
      if (index >= 0) {
        Object.assign(items[index], action.payload);
        // console.info("update index" + index + " id " + quickListId);
        // console.info(items[index].name);
      } else {
        // must be a new item, add to list
        items.push(action.payload);
      }

      //lists = updateQuickList(lists, action.payload.id, action.payload);
      //console.info("lists length" + lists.length + " last one " + lists[lists.length - 1].name);
      return {
        ...state,
        isFetchingQuickLists: false,
        quickLists: items
      };
    }
    case RECEIVE_QUICKLISTDELETE: {  // after delete we get a new list
      let items = cloneDeep(state.quickLists);
      items = items.filter(ql => ql.id !== action.payload.deletedId);
      return {
        ...state,
        quickLists: items,
        quickListsLoaded: true,
        isFetchingQuickLists: false
      };
    }
    case ERROR_QUICKLISTGROUP:
    case ERROR_QUICKLISTS:
      return {
        ...state,
        isFetchingQuickLists: false
      };
    case ERROR_QUICKLISTTEMPLATES:
      return {
        ...state,
        isFetchingQuickListTemplates: false
      };
    case ERROR_QUICKLISTCOUNT: {
      let lists = cloneDeep(state.quickLists);
      let currentList = lists.find(x => x.id === action.payload.id);
      if (currentList !== undefined) {
        currentList.count.isFetching = false;
      }
      return {
        ...state,
        quickLists: lists
      };
    }
    case ERROR_QUICKLISTRESULT: {
      let lists = cloneDeep(state.quickLists);
      let currentList = lists.find(x => x.id === action.payload.id);
      if (currentList !== undefined) {
        currentList.result.isFetching = false;
      }
      return {
        ...state,
        quickLists: lists
      };
    }
    case ERROR_QUICKLISTSAVE: {
      let lists = cloneDeep(state.quickLists);
      let currentList = lists.find(x => x.id === action.payload.id);
      if (currentList !== undefined) {
        currentList.result.isFetching = false;
      }
      return {
        ...state,
        quickLists: lists
      };
    }
    case ERROR_QUICKLISTDELETE:
      return {
        ...state,
        isFetchingQuickLists: false
      };
    case SET_CURRENT_QUICKLIST_ID:
      return {
        ...state,
        currentQuicklistId: action.payload,
      };
    case SET_CURRENT_QUICKLIST_ROW_INDEX:
      return {
        ...state,
        currentRowIndex: action.payload,
      };
    default:
      return state;
  }
};

export default quickList;